module.exports = __webpack_public_path__ + "img/banner-header_01-individuos-y-familias.4f13e0e2.png";